<div class="flex flex-row-reverse h-screen login-wrap" *transloco="let t" (keyup.enter)="onLoginButtonClick()">
  <div class="w-2/5">
    <div class="grid grid-rows-3 grid-cols-2 px-12 pt-24 pb-2 bg-grey-dark/60 h-full">
      <img src="assets/pwc-logo-bw-white.svg" alt="PwC" width="75px" />
      <language-switcher class="text-white"></language-switcher>
      <div class="mx-4 col-span-2 text-center">
        <h1 class="text-5xl font-thin text-white" style="letter-spacing: 1px;">{{ t('appname')}}</h1>
        <button pButton (click)="onLoginButtonClick()" [label]="t('login')"
          class="text-white border-none bg-orange-default mt-10 w-4/5"></button>
      </div>
      <span class="absolute justify-self-end text-xs select-none text-white/50 right-0 bottom-0 p-3">
        {{ appVersion }}
      </span>
    </div>
  </div>
</div>